const EMPTY_STRING = '';
export default function getCharactersTypedSinceRequest(
    charactersBeforeCursorAtTimeOfCurrentRequest: string,
    charactersBeforeCursor: string
): string {
    if (!charactersBeforeCursorAtTimeOfCurrentRequest || !charactersBeforeCursor) {
        return EMPTY_STRING;
    }

    if (charactersBeforeCursorAtTimeOfCurrentRequest.length >= charactersBeforeCursor.length) {
        return EMPTY_STRING;
    }

    if (charactersBeforeCursor.indexOf(charactersBeforeCursorAtTimeOfCurrentRequest) !== 0) {
        return EMPTY_STRING;
    }

    let retVal = EMPTY_STRING;
    for (
        let i = charactersBeforeCursorAtTimeOfCurrentRequest.length;
        i < charactersBeforeCursor.length;
        i++
    ) {
        retVal = retVal + charactersBeforeCursor.charAt(i);
    }

    return retVal;
}
